// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2otAY","rootNoMargin":"styles_rootNoMargin__2EUj0"};